'use es6';

import I18n from 'I18n';
import { renderToString } from 'react-dom/server';
import { formatPercent } from 'reporting-visualizations/formatters/propertyFormatter';
import { HR } from 'foundations-components/transitional/components/HR';
import { CustomHighchartsTooltip, TooltipHeader, TooltipBody, TooltipBodyListContainer, TooltipBodyLabel, TooltipBodyValue, TooltipSeriesSymbol } from '../../../../highcharts/options/customTooltipStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderTooltip = (sliceName, name, value, percentage, total, color) => {
  return renderToString( /*#__PURE__*/_jsxs(CustomHighchartsTooltip, {
    children: [/*#__PURE__*/_jsx(TooltipHeader, {
      children: sliceName
    }), /*#__PURE__*/_jsxs(TooltipBody, {
      children: [/*#__PURE__*/_jsxs(TooltipBodyListContainer, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(TooltipSeriesSymbol, {
          color: color
        }), /*#__PURE__*/_jsx(TooltipBodyLabel, {
          children: I18n.text('reporting-visualizations.tooltip.group', {
            group: I18n.SafeString(name)
          })
        }), /*#__PURE__*/_jsx(TooltipBodyValue, {
          children: value
        }), ' ', /*#__PURE__*/_jsxs(TooltipBodyValue, {
          children: ["(", formatPercent(percentage / 100), ")"]
        })]
      }), /*#__PURE__*/_jsx(HR, {
        distance: "extra-small"
      }, "hr"), /*#__PURE__*/_jsxs(TooltipBodyListContainer, {
        children: [/*#__PURE__*/_jsx(TooltipSeriesSymbol, {
          color: color
        }), /*#__PURE__*/_jsx(TooltipBodyLabel, {
          children: I18n.text('reporting-ui-components.tooltip.totals')
        }), /*#__PURE__*/_jsx(TooltipBodyValue, {
          children: total
        })]
      }, "totalsRow")]
    })]
  }));
};
export const getTooltipFormatter = (dataLabelPointFormatter, grandTotal) => {
  return function formatter() {
    return renderTooltip(this.key, this.series.name, dataLabelPointFormatter(this.y), this.percentage, dataLabelPointFormatter(grandTotal == null ? this.total : grandTotal), this.color);
  };
};